module.exports = __webpack_public_path__ + "static/media/fog.de8d4f07.svg";